function run() {
    getVersionList();
    ApiDiffTool.run();
  }
  
  function getJsonApiMap() {
    return jsonApiMap || {};
  }
  
  function getVersionList() {
    const versionList = Object.keys(getJsonApiMap());
    prepareDomSelectVersion(versionList);
  }
  
  function prepareDomSelectVersion(versionList) {
    const versionSource = document.querySelector('#versionSource');
    const versionDest = document.querySelector('#versionDest');
    if (!versionSource || !versionDest) {
      return;
    }
  
    // need to create to different copies for prepareDomOptionsVersion
    versionSource.appendChild(prepareDomOptionsVersion(versionList));
    versionSource.selectedIndex = 1;
    //
    versionDest.appendChild(prepareDomOptionsVersion(versionList));
    versionDest.selectedIndex = 0;
  }
  
  function prepareDomOptionsVersion(versionList) {
    const fragment = document.createDocumentFragment();
    versionList.forEach((ver) => {
      const selectOption = fragment.appendChild(document.createElement('option'));
      selectOption.text = ver.replace(/_/g, '.');
      selectOption.value = ver;
    });
    return fragment;
  }
  
  // converted to ES5 from homepage\views\api-diff.js
  // https://www.typescriptlang.org/play?target=1
  var ApiDiffTool = /** @class */ (function () {
    function ApiDiffTool() {
    }
    ApiDiffTool.run = function () {
        if (!this.diffToolContainer) {
            return;
        }
        this.clearUi();
        this.handleObjectComparisonVisualOption();
    };
    ApiDiffTool.getJsons = function () {
        const _this = this;
        this.clearUi();
        this.disableUi();
        
        _this.dataOutput = dataOutput = {
          src: jsonApiMap[versionSource.value],
          dest: jsonApiMap[versionDest.value],
        };
        console.log('getJsons result: ', _this.dataOutput);
        _this.prepareDiffs();
        const hasKeysSrc = 'json' in _this.dataOutput.src && Boolean(Object.keys(_this.dataOutput.src.json).length);
        const hasKeysDest = 'json' in _this.dataOutput.dest && Boolean(Object.keys(_this.dataOutput.dest.json).length);
        if (hasKeysSrc) {
            _this.showElem(_this.versionSourceDlJson);
        }
        else {
            _this.versionSourceError.innerHTML = _this.errors.cantFindVersion;
        }
        if (hasKeysDest) {
            _this.showElem(_this.versionDestDlJson);
        }
        else {
            _this.versionDestError.innerHTML = _this.errors.cantFindVersion;
        }
        if (hasKeysSrc && hasKeysDest) {
            _this.showElem(_this.btnPrint);
            _this.getGitLikeComparison(_this.gitLikeSelect.value);
            _this.getObjectComparison(_this.objectCompareSelectVal);
        }
        _this.enableUi();
    };
    ApiDiffTool.prepareObjToDiff = function (obj) {
        return (obj && obj.json && obj.json.definitions) || {};
    };
    ApiDiffTool.clearUi = function () {
        this.versionSourceError && (this.versionSourceError.innerHTML = '');
        this.versionDestError && (this.versionDestError.innerHTML = '');
        this.hideElem(this.versionSourceDlJson);
        this.hideElem(this.versionDestDlJson);
        this.hideElem(this.btnPrint);
        this.gitLikeResult && (this.gitLikeResult.innerHTML = '');
        this.objectCompareResult && (this.objectCompareResult.innerHTML = '');
        this.dataOutput = {};
    };
    /** GitHub style */
    ApiDiffTool.getGitLikeComparison = function (outputFormat) {
        if (outputFormat === void 0) { outputFormat = 'side-by-side'; }
        if (!Object.keys(this.dataOutput || {}).length) {
            return;
        }
        const configuration = { drawFileList: true, matching: 'lines', outputFormat: outputFormat };
        const diff2htmlUi = new Diff2HtmlUI(this.gitLikeResult, this.dataOutput.diffString, configuration);
        diff2htmlUi.draw();
        if (outputFormat === 'side-by-side') {
            this.equalizeTrsForTwoTables();
        }
    };
    ApiDiffTool.getObjectComparison = function (formatter) {
        if (formatter === void 0) { formatter = 'html'; }
        this.handleObjectComparisonVisualOption();
        if (!Object.keys(this.dataOutput || {}).length) {
            return;
        }
        switch (this.objectCompareSelectVal) {
            case 'annotated':
                formatter = 'annotated'; // self-explained json
                break;
            default:
                formatter = 'html'; // beautiful html diff
                this.toggleObjectComparisonVisualUnchanged();
        }
        const diffSrc = this.prepareObjToDiff(this.dataOutput.src);
        this.objectCompareResult.innerHTML = jsondiffpatch.formatters[formatter].format(this.dataOutput.delta, diffSrc);
    };
    ApiDiffTool.prepareDiffs = function () {
        const diffSrc = this.prepareObjToDiff(this.dataOutput.src);
        const diffDest = this.prepareObjToDiff(this.dataOutput.dest);
        // for GitHub style
        // createTwoFilesPatch
        this.dataOutput.diffString = Diff.createPatch('json', JSON.stringify(diffSrc, null, 2), JSON.stringify(diffDest, null, 2));
        //
        // for Object Comparison
        const jsondiffpatchInstance = jsondiffpatch.create({});
        this.dataOutput.delta = jsondiffpatchInstance.diff(diffSrc, diffDest);
    };
    ApiDiffTool.handleObjectComparisonVisualOption = function () {
        if (!this.objectCompareSelectVal) {
            return;
        }
        switch (this.objectCompareSelectVal) {
            case 'visual':
                this.showElem(this.objectCompareVisualShowUnchangedWrapper);
                break;
            default:
                this.hideElem(this.objectCompareVisualShowUnchangedWrapper);
        }
    };
    ApiDiffTool.toggleObjectComparisonVisualUnchanged = function () {
        const checkbox = this.objectCompareVisualShowUnchanged;
        const isShowUnchanged = checkbox ? checkbox.checked : false;
        const delay = 10;
        if (isShowUnchanged) {
            jsondiffpatch.formatters.html.showUnchanged(true, this.objectCompareResult, delay);
        }
        else {
            jsondiffpatch.formatters.html.hideUnchanged(this.objectCompareResult, delay);
        }
    };
    ApiDiffTool.downloadObjectAsJson = function (event, key) {
        event.preventDefault();
        const map = {
            versionSource: 'src',
            versionDest: 'dest',
        };
        if (!(key in map)) {
            return;
        }
        const info = this.dataOutput[map[key]];
        if (!info) {
            return;
        }
        // prepare anchor to download json
        const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(info.json));
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', dataStr);
        downloadAnchorNode.setAttribute('download', info.jsonFilename);
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    };
    ApiDiffTool.printElemNative = function () {
        const _this = this;
        const printWindow = this.prepareWindowForPrint();
        const elemCopy = this.prepareElementForPrint(this.diffToolContainer);
        printWindow.document.body.appendChild(elemCopy);
        setTimeout(function () {
            _this.equalizeTrsForTwoTables(elemCopy); // no needs to include scripts inside new window: this function changes new window DOM from here
            // onreadystatechange, onload don't work with child window. setTimeout is the easiest way.
            _this.runPrintInWindow(printWindow);
        }, 800);
    };
    ApiDiffTool.prepareWindowForPrint = function () {
        const width = this.printWidth;
        const height = 600;
        const left = screen.width / 2 - width / 2;
        const top = screen.height / 2 - height / 2;
        const printWindow = window.open('', 'PRINT', "width=".concat(width, ",height=").concat(height, ",toolbar=0,scrollbars=0,status=0,left=").concat(left, ",top=").concat(top));
        const linksStr = '';
        for (let _i = 0, _a = document.querySelectorAll('link[rel="stylesheet"], style'); _i < _a.length; _i++) {
            const styleElem = _a[_i];
            linksStr += styleElem.outerHTML;
        }
        const state = this.dataInput;
        const filename = "diff-tool_".concat(state.src, "_").concat(state.dest, ".pdf");
        printWindow.document.write("<html>\n        <head>\n          <title>".concat(filename, "</title>\n          ").concat(linksStr, "\n        </head>\n        <body>\n          <h3 class=\"section-title\">API Version Diff Tool</h3>\n        </body>\n      </html>"));
        return printWindow;
    };
    ApiDiffTool.runPrintInWindow = function (printWindow) {
        printWindow.document.close();
        printWindow.focus();
        printWindow.onafterprint = function () {
            printWindow.close();
        };
        printWindow.print();
    };
    /**
     * Clone element and make changes inside
    */
    ApiDiffTool.prepareElementForPrint = function (elemOriginal) {
        // copy DOM node
        const elemCopy = elemOriginal.cloneNode(true);
        // restore selects
        ['versionSource', 'versionDest', 'gitLikeSelect' /* , 'objectCompareSelect' */].forEach(function (idName) {
            elemCopy.querySelector("#".concat(idName)).value = elemOriginal.querySelector("#".concat(idName)).value;
        });
        // expand collapses
        [elemCopy.querySelector('#gitLikeStyle'), elemCopy.querySelector('#objectCompareStyle')].forEach(function (elemItem) {
            if (elemItem) {
                elemItem.checked = true;
            }
        });
        // // change some HTML element values
        // this.objectCompareVisualShowUnchanged.checked = false; // false to reduce image because PDF can be corrupted
        elemCopy.style.width = "".concat(this.printWidth, "px");
        elemCopy.id = "".concat(elemCopy.id, "Copy");
        elemCopy.classList.add('diff-tool-for-print');
        return elemCopy;
    };
    ApiDiffTool.equalizeTrsForTwoTables = function (elem) {
        elem = elem || this.diffToolContainer;
        const tables = elem.querySelectorAll('.d2h-files-diff table.d2h-diff-table');
        if (tables.length !== 2) {
            return;
        }
        const table2 = tables[1];
        tables[0].querySelectorAll('tr').forEach(function (table1Tr, trInd) {
            const table1TrHeight = table1Tr.clientHeight;
            const table2Tr = table2.querySelector("tr:nth-child(".concat(trInd + 1, ")"));
            if (table2Tr) {
                const table2TrHeight = table2Tr.clientHeight;
                if (table1TrHeight > table2TrHeight) {
                    table2Tr.setAttribute('height', table1TrHeight);
                }
                else if (table1TrHeight < table2TrHeight) {
                    table1Tr.setAttribute('height', table2TrHeight);
                }
            }
        });
    };
    ApiDiffTool.showElem = function (elem) {
        if (!elem) {
            return;
        }
        elem.classList.remove('diff-tool-d-none');
    };
    ApiDiffTool.hideElem = function (elem) {
        if (!elem) {
            return;
        }
        elem.classList.add('diff-tool-d-none');
    };
    ApiDiffTool.disableUi = function () {
        const _this = this;
        this.lockingUiElems.forEach(function (elem) {
            _this.disableElem(elem);
        });
    };
    ApiDiffTool.disableElem = function (elem) {
        if (!elem) {
            return;
        }
        elem.setAttribute('disabled', '');
    };
    ApiDiffTool.enableUi = function () {
        const _this = this;
        this.lockingUiElems.forEach(function (elem) {
            _this.enableElem(elem);
        });
    };
    ApiDiffTool.enableElem = function (elem) {
        if (!elem) {
            return;
        }
        elem.removeAttribute('disabled');
    };
    Object.defineProperty(ApiDiffTool, "dataInput", {
        get: function () {
            return {
                /** select */
                src: this.versionSource.value,
                /** select */
                dest: this.versionDest.value,
                /** select */
                gitLikeOutputFormat: this.gitLikeSelect.value,
                /** select */
                objectCompareOutputFormat: this.objectCompareSelectVal,
                /** checkbox */
                objectCompareVisualShowUnchanged: this.objectCompareVisualShowUnchanged.checked,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "lockingUiElems", {
        get: function () {
            return [this.btnSubmit, this.versionSource, this.versionDest];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "errors", {
        get: function () {
            return {
                cantFindVersion: 'Cannot find version',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "diffToolContainer", {
        // optional variables because browser creates these variables automatically
        get: function () { return document.getElementById('diffToolContainer'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "versionSource", {
        get: function () { return this.diffToolContainer.querySelector('#versionSource'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "versionSourceError", {
        get: function () { return this.diffToolContainer.querySelector('#versionSourceError'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "versionSourceDlJson", {
        get: function () { return this.diffToolContainer.querySelector('#versionSourceDlJson'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "versionDest", {
        get: function () { return this.diffToolContainer.querySelector('#versionDest'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "versionDestError", {
        get: function () { return this.diffToolContainer.querySelector('#versionDestError'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "versionDestDlJson", {
        get: function () { return this.diffToolContainer.querySelector('#versionDestDlJson'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "btnSubmit", {
        get: function () { return this.diffToolContainer.querySelector('#btnSubmit'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "btnPrint", {
        get: function () { return this.diffToolContainer.querySelector('#btnPrint'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "gitLikeSelect", {
        get: function () { return this.diffToolContainer.querySelector('#gitLikeSelect'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "gitLikeResult", {
        get: function () { return this.diffToolContainer.querySelector('#gitLikeResult'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "objectCompareSelect", {
        get: function () { return this.diffToolContainer.querySelector('#objectCompareSelect'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "objectCompareSelectVal", {
        get: function () { return this.objectCompareSelect ? this.objectCompareSelect.value : 'visual'; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "objectCompareVisualShowUnchangedWrapper", {
        get: function () { return this.diffToolContainer.querySelector('#objectCompareVisualShowUnchangedWrapper'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "objectCompareVisualShowUnchanged", {
        get: function () { return this.diffToolContainer.querySelector('#objectCompareVisualShowUnchanged'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "objectCompareResult", {
        get: function () { return this.diffToolContainer.querySelector('#objectCompareResult'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiDiffTool, "printWidth", {
        get: function () {
            return 1080;
        },
        enumerable: false,
        configurable: true
    });
    ApiDiffTool.dataOutput = {};
    return ApiDiffTool;
}());
   


// WEBPACK FOOTER //
// ../../../../../root/api-docs/assets/js/api-diff-tool/script-api-diff-tool.js